import { TelegramApi } from "@/shared/error-boundary/api";

import { AmplitudeApiParams } from "./models";

export abstract class AmplitudeApi {
  // if typescript error appears "Property 'amplitude' does not exist on type 'AmplitudeApiParams'."
  // DO NOT CHANGE PARAMETERS. You need to add "amplitude" key to the object you are passing
  static async send({ amplitude, ...rest }: AmplitudeApiParams) {
    try {
      if (process.env.SITE_ENV === "prod") {
        window.amplitude.track(amplitude, rest);
        return;
      }

      await TelegramApi.send(
        `amplitude: ${amplitude} | ${JSON.stringify(rest)}`,
      );
    } catch (e) {
      console.error(e);
    }
  }
}
